import { ICON_BASE_PATH } from "../../../../utils/config";

interface GxFilterButtonProps {
  onClick?: () => void;
  onActiveClick?: () => void; // handler for active state
  className?: string;
  active?: boolean; // toggle active state
}

const GxFilterButton: React.FC<GxFilterButtonProps> = ({
  onClick,
  onActiveClick,
  className = "",
  active = false,
}) => {
  const handleClick = () => {
    if (active && onActiveClick) {
      onActiveClick();
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`cursor-pointer rounded-full 
        border border-transparent
        bg-black
        hover:shadow-[0_4px_12px_rgba(0,0,0,0.12)]
        transition-all duration-300
        w-10
        h-10
        flex justify-center items-center
        ${className}`}
    >
      {active ? (
        <img
          src={`${ICON_BASE_PATH}cross-w.svg`}
          alt="close filter"
          className="w-3 h-3 transform transition duration-300 ease-in-out hover:scale-110 animate-fadeIn"
        />
      ) : (
        <img
          src={`${ICON_BASE_PATH}bi_filter.svg`}
          alt="filter"
          className="w-5 h-5 transform transition duration-300 ease-in-out hover:scale-110 animate-fadeIn"
        />
      )}
    </button>
  );
};

export default GxFilterButton;
